import { Team } from '@dispatch/shared/types';

export function useGetCompanyTeamOptions(teams: Team[]) {
  const companyTeamOptions = teams?.map((team) => {
    return { value: team.integrationGUID, title: team?.name || '' };
  });

  return {
    companyTeams: companyTeamOptions,
  };
}
